import './_LoaderSpinner.scss';

export default function LoaderSpinner() {
  return (
    <div className='spinner__container'>
      <div className='spinner' />
    </div>
  );
}
